import React, {Component, ChangeEvent, FormEvent} from 'react'

import {ComponentStatus, Grid} from '@influxdata/clockface'
import CSRF from 'js/components/CSRF'

import MarketplaceSplashContents from './MarketplaceSplashContents'
import OrganicSplashPageContents from './OrganicSplashPageContents'
import {Marketplace} from 'js/types/marketplace'

import {isFlagEnabled} from '../FeatureFlags/FeatureFlag'

interface State {
  isAgreeingToTerms: boolean
  hasSubmittedForm: boolean
  company: string
  organization: string
  firstName: string
  lastName: string
}

interface Props {
  marketplace?: Marketplace
}

class SplashPageContents extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      isAgreeingToTerms: false || !!props.marketplace,
      hasSubmittedForm: false,
      company: '',
      organization: '',
      firstName: '',
      lastName: '',
    }
  }

  render() {
    const {isAgreeingToTerms, company, organization, firstName, lastName} =
      this.state
    const {marketplace} = this.props

    return (
      <Grid className="sign-up--splash">
        <form
          action="/orgs"
          method="POST"
          onSubmit={this.handleSubmit}
          data-testid="splash-form"
        >
          {marketplace ? (
            <MarketplaceSplashContents
              buttonStatus={this.continueStatus}
              marketplace={marketplace}
              company={company}
              organization={organization}
              firstName={firstName}
              lastName={lastName}
              companyError={this.showCompanyError}
              organizationError={this.showOrganizationError}
              firstNameError={this.showFirstNameError}
              lastNameError={this.showLastNameError}
              handleChangeCompany={this.handleChangeCompany}
              handleChangeOrganization={this.handleChangeOrganization}
              handleChangeFirstName={this.handleChangeFirstName}
              handleChangeLastName={this.handleChangeLastName}
            />
          ) : (
            <OrganicSplashPageContents
              isAgreeingToTerms={isAgreeingToTerms}
              handleChangeRegion={this.handleChangeRegion}
              handleAgreement={this.handleAgreement}
              showReminder={this.showReminder}
              buttonStatus={this.continueStatus}
              company={company}
              organization={organization}
              firstName={firstName}
              lastName={lastName}
              companyError={this.showCompanyError}
              organizationError={this.showOrganizationError}
              firstNameError={this.showFirstNameError}
              lastNameError={this.showLastNameError}
              handleChangeCompany={this.handleChangeCompany}
              handleChangeOrganization={this.handleChangeOrganization}
              handleChangeFirstName={this.handleChangeFirstName}
              handleChangeLastName={this.handleChangeLastName}
            />
          )}
          <CSRF />
        </form>
      </Grid>
    )
  }

  private get continueStatus(): ComponentStatus {
    const {company, hasSubmittedForm, isAgreeingToTerms} = this.state
    if (hasSubmittedForm && isAgreeingToTerms && company.length > 0) {
      return ComponentStatus.Loading
    }

    return ComponentStatus.Default
  }

  private get showReminder(): boolean {
    const {hasSubmittedForm, isAgreeingToTerms} = this.state

    return hasSubmittedForm && !isAgreeingToTerms
  }

  private get showCompanyError(): string {
    const {company, hasSubmittedForm} = this.state
    return company === '' && hasSubmittedForm
      ? 'Please enter a company name to proceed'
      : ''
  }

  private get showOrganizationError(): string {
    const {organization, hasSubmittedForm} = this.state
    return organization === '' && hasSubmittedForm
      ? 'Please enter an organization name to proceed'
      : ''
  }

  private get showFirstNameError(): string {
    const {firstName, hasSubmittedForm} = this.state
    return firstName === '' && hasSubmittedForm
      ? 'Please enter a first name to proceed'
      : ''
  }

  private get showLastNameError(): string {
    const {lastName, hasSubmittedForm} = this.state
    return lastName === '' && hasSubmittedForm
      ? 'Please enter a last name to proceed'
      : ''
  }

  private handleChangeRegion = (infoBefore, infoAfter) => {
    if (infoBefore === infoAfter) return
    const {marketplace} = this.props

    this.setState({
      isAgreeingToTerms: false || !!marketplace,
    })
  }

  private handleChangeCompany = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({company: e.target.value, hasSubmittedForm: false})
  }

  private handleChangeOrganization = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({organization: e.target.value, hasSubmittedForm: false})
  }

  private handleChangeFirstName = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({firstName: e.target.value, hasSubmittedForm: false})
  }

  private handleChangeLastName = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({lastName: e.target.value, hasSubmittedForm: false})
  }

  private handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    const {isAgreeingToTerms, company, organization, firstName, lastName} =
      this.state
    if (isFlagEnabled('auth0UniversalLoginEnabled', 'true')) {
      if (
        !isAgreeingToTerms ||
        company === '' ||
        organization === '' ||
        firstName === '' ||
        lastName === ''
      ) {
        e.preventDefault()
      }
    } else {
      if (!isAgreeingToTerms || company === '' || organization === '') {
        e.preventDefault()
      }
    }

    this.setState({hasSubmittedForm: true})
  }

  private handleAgreement = () => {
    const {isAgreeingToTerms} = this.state

    this.setState({
      isAgreeingToTerms: !isAgreeingToTerms,
      hasSubmittedForm: false,
    })
  }
}

export default SplashPageContents
